import { RouterProvider } from "react-router-dom";

import useCheckoutPageProps from "@hooks/useCheckoutPageProps";

import checkoutRouter from "@routers/checkoutRouter";
import { useSetAtom } from "jotai";

import { checkoutAtom, productFamilyUrlAtom } from "@atoms/checkoutAtom.ts";

const Checkout = () => {
    const { parentUser, productFamilyUrl } = useCheckoutPageProps();

    const setProductFamilyUrl = useSetAtom(productFamilyUrlAtom);
    const setCheckout = useSetAtom(checkoutAtom);
    setProductFamilyUrl(productFamilyUrl);
    /**
     * If a parent is logged into the portal, we pre-initialize the user info for the chekout portal
     * based on the logged in parent's data
     */
    if (parentUser) {
        setCheckout(prev => ({
            ...prev,
            user: {
                firstName: parentUser.firstName,
                email: parentUser.email,
                receiveOfferNews: true
            }
        }));
    }

    return <RouterProvider router={checkoutRouter} />;
};

export default Checkout;
